import React, { forwardRef } from 'react';
import { AlertCircle } from 'lucide-react';
import './textInput.css';

interface TextInputProps {
    value: string | number | undefined;
    onChange: (value: string) => void;
    onEnter?: (value: string) => void;
    id?: string;
    placeholder?: string;
    disabled?: boolean;
    onBlur?: () => void;
    width?: number;
    height?: number;
    showError?: boolean;
    errorMessage?: string;
}

const TextInput = forwardRef<HTMLInputElement, TextInputProps>(({
    value,
    onChange,
    onEnter,
    id,
    placeholder,
    disabled = false,
    onBlur,
    width,
    height = 30,
    showError = false,
    errorMessage = 'Invalid input',
}, ref) => {
    
    // Handle display value properly for numbers including 0
    const displayValue = value !== undefined && value !== null ? String(value) : '';

    // Handle key press events
    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === 'Enter' && onEnter) {
            onEnter(displayValue);
        }
    };

    return (
        <div className="textInput-container" style={{ position: 'relative', display: 'inline-block' }}>
            <input
                ref={ref}
                id={id}
                value={displayValue}
                onChange={(e) => onChange(e.target.value)}
                onKeyDown={handleKeyDown}
                onBlur={onBlur}
                placeholder={placeholder}
                className="textInput-inputField"
                disabled={disabled}
                style={{ width: width ? `${width}px` : '100%', height: `${height}px` }}
            />
            {showError && (
                <div 
                    className="textInput-errorIcon"
                    title={errorMessage}
                    style={{
                        position: 'absolute',
                        right: '8px',
                        top: '50%',
                        transform: 'translateY(-50%)',
                        color: 'var(--color-red-default, #dc3545)',
                        cursor: 'help'
                    }}
                >
                    <AlertCircle size={16} />
                </div>
            )}
        </div>
    );
});

TextInput.displayName = 'TextInput';

export default TextInput;